import React from "react";
import { Button, Radio } from "antd";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// Validation schema
const validationSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  file: Yup.mixed().when("type", {
    is: "pdf",
    then: Yup.mixed().required("PDF file is required"),
    otherwise: Yup.mixed().notRequired(),
  }),
  templateContent: Yup.string().when("type", {
    is: "template",
    then: Yup.string().required("Template content is required"),
    otherwise: Yup.string().notRequired(),
  }),
});

export default function AddTermsAndConditions({ onSubmit }) {
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const newTerm = {
      type: values.type,
      name: values.type === "pdf" ? values.file?.name || "Uploaded PDF" : "Template Content",
      content: values.type === "template" ? values.templateContent : "PDF File",
    };
    onSubmit(newTerm);
    resetForm();
    setSubmitting(false);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md my-6 max-w-2xl mx-auto">
      <Formik
        initialValues={{ type: "pdf", file: null, templateContent: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue, values }) => (
          <Form className="space-y-6">
            <div className="flex flex-col space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Content Type
                </label>
                <Field name="type">
                  {({ field }) => (
                    <Radio.Group
                      {...field}
                      onChange={(e) => setFieldValue("type", e.target.value)}
                      className="flex space-x-4"
                    >
                      <Radio value="pdf" className="text-gray-600">Pdf</Radio>
                      <Radio value="template" className="text-gray-600">Template</Radio>
                    </Radio.Group>
                  )}
                </Field>
                <ErrorMessage
                  name="type"
                  component="div"
                  className="text-red-500 text-sm mt-1"
                />
              </div>

              <div>
                {values.type === "pdf" ? (
                  <div>
                    <label
                      htmlFor="file"
                      className="block text-sm font-semibold text-gray-700 mb-2"
                    >
                      Upload PDF
                    </label>
                    <input
                      id="file"
                      name="file"
                      type="file"
                      accept=".pdf"
                      className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      onChange={(event) => {
                        setFieldValue("file", event.currentTarget.files[0]);
                      }}
                    />
                    <ErrorMessage
                      name="file"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                ) : (
                  <div>
                    <label
                      htmlFor="templateContent"
                      className="block text-sm font-semibold text-gray-700 mb-2"
                    >
                      Template Content
                    </label>
                    <Field
                      as="textarea"
                      name="templateContent"
                      className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      rows="8"
                      placeholder="Enter terms and conditions content"
                    />
                    <ErrorMessage
                      name="templateContent"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                )}
              </div>

              <div className="flex justify-end">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="px-6 py-2 bg-blue-600 hover:bg-blue-700"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Adding..." : "Add Terms"}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}